import React, { FC, useContext } from "react";
import { observer } from 'mobx-react-lite';
import { TreeNode, TreeNodeLabel } from '../../TreeNode';
import { InstructionNodeProps } from '../InstructionNodeFactory';
import { LeftPaneContext } from '../../../LeftPaneContext';
import { SettingInstruction } from '../../../../../../machinelogic/types';

interface SystemNodeProps extends Omit<InstructionNodeProps, 'instruction'> {
  instruction: SettingInstruction
}

interface InstructionLabelProps {
  instruction: SettingInstruction;
}

const InstructionLabel: FC<InstructionLabelProps> = observer(({instruction}) => {

  const { library } = useContext(LeftPaneContext);
  const getAxisByUuid = (uuid) => library.getConfigManager().getAxisByUuid(uuid);

  switch(instruction.name) {
    case "setAcceleration":
      return <>Set System Acceleration {instruction.parameters.acceleration} mm/s<sup>2</sup></>;
    case "setSpeed":
      return <>Set System Speed {instruction.parameters.speed} mm/s</>;
    case "setActuatorAcceleration": {
      const axis = getAxisByUuid(instruction.parameters.axis);
      const axisName = axis ? axis.name : 'UNKNOWN Axis';
      return <>Set {axisName} Acceleration {instruction.parameters.acceleration} mm/s<sup>2</sup></>;
    }
    case "setActuatorSpeed": {
      const axis = getAxisByUuid(instruction.parameters.axis);
      const axisName = axis ? axis.name : 'UNKNOWN Axis';
      return <>Set {axisName} Speed {instruction.parameters.speed} mm/s</>;
    }
  }
});


export const SettingNode: FC<SystemNodeProps> = observer(({instruction, titleClassName = '', isSelected, isInvalid, onClick}) => {

  const name = <InstructionLabel instruction={instruction} />;

  const instructionLabel = <TreeNodeLabel
    icon='icon-motor'
    name={name}
    isSelected={isSelected}
    isInvalid={isInvalid}
    onClick={onClick}
  />;

  return (
    <TreeNode title={instructionLabel} titleClassName={titleClassName} />
  );
});
